import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import api from '@/api'
import { getCookie, setCookie } from '@/utils/cookie'
import {
  getShoppingCartNum,
  getSmShoppingCartNum,
  getUserName
} from '@/plugins/common'
import dayjs from 'dayjs'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/Rccl.Pcp/Home/Index'
    },
    {
      path: '/Rccl.Pcp/Home/Index',
      name: 'Index',
      component: () => import('./views/PageIndex.vue')
    },
    {
      path: '/login',
      redirect: '/Orchard.Rccl.Users/Login/Login?viewSource=PCP&returnUrl='
    },
    {
      path: '/Orchard.Rccl.Users/Login/Login?viewSource=PCP&returnUrl=',
      name: 'Login',
      component: () => import('./views/PageLogin.vue'),
      meta: {
        title: '登录注册',
        noCache: true
      }
    },
    {
      path: '/page_news_list',
      redirect: '/Rccl.PCP/news/index'
    },
    {
      path: '/Rccl.PCP/news/index',
      name: 'PageNewsList',
      component: () => import('./views/PageNewsList.vue'),
      meta: { title: '新闻中心' }
    },
    {
      path: '/page_news_detail',
      redirect: '/Rccl.PCP/news/Detail'
    },
    {
      path: '/Rccl.PCP/news/Detail',
      name: 'PageNewsDetail',
      component: () => import('./views/PageNewsDetail.vue'),
      meta: { title: '新闻中心' }
    },
    {
      path: '/page_beginners_tips',
      redirect: '/Rccl.PCP/UserGuide/Index'
    },
    {
      path: '/Rccl.PCP/UserGuide/Index',
      name: 'PageBeginnersTips',
      component: () => import('./views/PageBeginnersTips.vue'),
      meta: { title: '用户指南' }
    },
    {
      path: '/page_question',
      redirect: '/Rccl.PCP/FAQ/Index'
    },
    {
      path: '/Rccl.PCP/FAQ/Index',
      name: 'PageQuestion',
      component: () => import('./views/PageQuestion.vue'),
      meta: { title: '常见问题' }
    },
    {
      path: '/page_combination',
      redirect: '/Rccl.PCP/combo/index/1'
    },
    {
      path: '/Rccl.PCP/combo/index/1',
      name: 'PageCombination',
      component: () => import('./views/PageCombination.vue'),
      meta: { title: '推荐组合' }
    },
    {
      path: '/page_shopping_cart',
      redirect: '/Rccl.PCP/order/ShoppingCart'
    },
    {
      path: '/Rccl.PCP/order/ShoppingCart',
      name: 'PageShoppingCart',
      component: () => import('./views/PageShoppingCart.vue'),
      meta: { title: '购物车' }
    },
    {
      path: '/page_order_detail',
      redirect: '/Rccl.PCP/Order/Checkout'
    },
    {
      path: '/Rccl.PCP/Order/Checkout',
      name: 'PageOrderDetail',
      component: () => import('./views/PageOrderDetail.vue'),
      meta: {
        title: '活动订单详情',
        noCache: true
      }
    },
    {
      path: '/pgae_order_success',
      redirect: '/Rccl.PCP/Order/Confirm'
    },
    {
      path: '/Rccl.PCP/Order/Confirm',
      name: 'PgaeOrderSuccess',
      component: () => import('./views/PgaeOrderSuccess.vue'),
      meta: { title: '订单提交成功' }
    },
    {
      path: '/bind_ticket',
      redirect: '/Rccl.PCP/Order/BookingSearchPcp'
    },
    {
      path: '/Rccl.PCP/Order/BookingSearchPcp',
      name: 'bindTicket',
      component: () => import('./views/PageBindTicket.vue'),
      meta: { title: '绑定船票订单' }
    },
    {
      path: '/bind_success',
      name: 'bindSuccess',
      component: () => import('./views/PageBindSuccess.vue'),
      meta: { title: '绑定船票订单' }
    },
    {
      path: '/Rccl.PCP/product/:type',
      name: 'PageBooking',
      props: true,
      component: () => import('./views/PageBooking.vue'),
      meta: { noCache: true }
    },
    {
      path: '/Rccl.PCP/product/detail/:id',
      name: 'PageProductDetail',
      props: true,
      component: () => import('./views/PageProductDetail.vue'),
      meta: { noCache: true }
    },
    {
      path: '/terms',
      redirect: '/Rccl.PCP/Policy/Index'
    },
    {
      path: '/Rccl.PCP/Policy/Index',
      name: 'PageTerms',
      component: () => import('./views/PageTerms.vue'),
      meta: { title: '服务条款' }
    },
    {
      path: '/product_search',
      redirect: '/Rccl.PCP/search/search'
    },
    {
      path: '/Rccl.PCP/search/search',
      name: 'PageProductSearch',
      component: () => import('./views/PageProductSearch.vue')
    },
    {
      path: '/shoppingmall/search',
      name: 'shoppingMallSearch',
      component: () => import('@/views/ShoppingMall/Search.vue')
    },
    {
      path: '/shoppingmall',
      name: 'shoppingmall',
      component: () => import('@/views/ShoppingMall/Search.vue')
    },
    {
      path: '/404',
      name: 'Page404',
      component: () => import('./views/Page404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  from = from || ''
  const userAgentInfo = navigator.userAgent
  const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  const token = to.query.token || getCookie('token')
  window.wx.miniProgram.getEnv(res => {
    store.commit('store', {
      isMiniApp: res.miniprogram
    })
  })
  if (!agents.filter(x => userAgentInfo.indexOf(x) >= 0).length && window.__wxjs_environment !== 'miniprogram') {
    location.href = process.env.VUE_APP_PC
  } else if (token && !store.getters.isLogin) {
    const { bookingId, shipCode, sailDate } = to.query
    store.commit('store', { token })
    setCookie('token', token)
    if (bookingId && shipCode && sailDate) await api.loginAndBindingFromBookingMiniApp({ accessToken: token, bookingId, shipCode, sailDate })
    const { errCode, data } = await api.getBookingInfo()
    if (errCode === 0) {
      const { rcclUser, ...bindTicket } = data

      store.commit('store', {
        userName: getUserName(rcclUser),
        bindTicket: bindTicket.bookingId === null ? '' : bindTicket
      })
      if (bindTicket.bookingId !== null) {
        store.commit('updateBindTicket', {
          ...data,
          bookingRemind: `您的行前预订功能将于 ${dayjs(data.sailDateBegin).subtract(3, 'd').format('YYYY年MM月DD日')} 11:59pm 截止`
        })
      }
      await getShoppingCartNum()
      await getSmShoppingCartNum()
      if (rcclUser && rcclUser.id > 0 && window.gio) {
        try {
          window.gio('setUserId', rcclUser.id)
        } catch (e) {
          console.error(e)
        }
      }
    } else {
      store.commit('store', { token: '' })
    }
    next()
  } else {
    next()
  }
})

router.afterEach((to) => {
  if (store.state.depthHistory.indexOf(to.path) < 0) window.scrollTo(0, 0)
})

export default router
